module.exports = __webpack_public_path__ + "static/media/choix-upload-cg.03fbb663.svg";